export enum DataStatus {
  NO_DATA = -1,
  HAS_DATA = 1,
}

export const DataStatusLabel: Record<DataStatus, string> = {
  [DataStatus.NO_DATA]: 'No Data',
  [DataStatus.HAS_DATA]: 'Has Data',
};

export const DataStatusCodeMap: Record<DataStatus, DataStatus> = {
  [DataStatus.NO_DATA]: DataStatus.NO_DATA,
  [DataStatus.HAS_DATA]: DataStatus.HAS_DATA,
};

export function getDataStatusFromCode(code: number): DataStatus {
  return DataStatusCodeMap[code as DataStatus] ?? DataStatus.NO_DATA;
}
